var map = {
	"./Apple_Pay_Mark_RGB_041619.svg": 368,
	"./Visa_Brandmark_Blue_RGB_2021.png": 369,
	"./Visa_Brandmark_White_RGB_2021.png": 370,
	"./arrow-down-blue.svg": 659,
	"./arrow-down-grey.svg": 660,
	"./arrow-right-white.png": 661,
	"./arrow-right.svg": 662,
	"./avalanche_token_round.png": 663,
	"./big_unicorn.png": 371,
	"./binance-coin-bnb-logo.png": 372,
	"./blue-loader.svg": 102,
	"./circle-grey.svg": 664,
	"./circle.svg": 665,
	"./coinbaseWalletIcon.svg": 221,
	"./dropdown-blue.svg": 666,
	"./dropdown.svg": 667,
	"./dropup-blue.svg": 668,
	"./earth.png": 373,
	"./ethereum-logo.png": 669,
	"./fortmaticIcon.png": 670,
	"./index/chars_icon.png": 671,
	"./index/farm_icon.png": 672,
	"./index/logo_icon.png": 673,
	"./index/pool_icon.png": 674,
	"./index/swap_icon.png": 675,
	"./link.svg": 676,
	"./logo.png": 220,
	"./magnifying-glass.svg": 677,
	"./mc_hrz_pos_black.svg": 374,
	"./mc_hrz_rev_white.svg": 375,
	"./menu.svg": 678,
	"./metamask.png": 367,
	"./migration_vector.png": 376,
	"./noise.png": 377,
	"./pizza_logo.png": 679,
	"./plus-blue.svg": 680,
	"./plus-grey.svg": 681,
	"./portisIcon.png": 682,
	"./question-mark.svg": 683,
	"./question.svg": 684,
	"./spinner.svg": 685,
	"./token-list/lists-dark.png": 686,
	"./token-list/lists-light.png": 687,
	"./token-logo.png": 223,
	"./trustWallet.png": 688,
	"./walletConnectIcon.svg": 222,
	"./x.svg": 689,
	"./xl_uni.png": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;